import { updateField } from 'vuex-map-fields';

export default {
  START_LOADING_WEBHOOK_TYPES(state) {
    state.webhookTypesLoaded = false;
  },
  SET_WEBHOOK_TYPES(state, payload) {
    state.webhookTypes = payload;
    state.webhookTypesLoaded = true;
  },
  START_LOADING_WEBHOOK_LOGS(state) {
    state.webhookLogsLoaded = false;
  },
  SET_WEBHOOK_LOGS(state, payload) {
    state.webhookLogs = payload;
    state.webhookLogsLoaded = true;
  },
  START_LOADING_WEBHOOKS(state) {
    state.webhooksLoaded = false;
  },
  SET_WEBHOOKS(state, payload) {
    state.webhooks = payload;
    state.webhooksLoaded = true;
  },
  WEBHOOK_SAVED(state, payload) {
    state.webhookSaved = payload;
  },
  WEBHOOK_DELETED(state, payload) {
    state.webhookDeleted = payload;
  },
  API_ERROR(state, payload) {
    if (payload) {
      state.apiError = payload;
    }
  },
  updateField,
};
